import { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetail } from '../redux/slices/adminSlice';
import { getAppointmentDetail } from '../redux/slices/appointmentSlice';

function AppointmentDetail() {
    const { id } = useParams()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAppointmentDetail(id))
    }, [dispatch])
    const { appointmentData } = useSelector((state) => state?.appointment)
    console.log(appointmentData)

    return (
        <>
            <AdminSidebar renderContent={
                <>
                    <Card
                        title="User Detail"
                        style={{ marginBottom: 24 }}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                <p>Name : {`${appointmentData?.data?.user?.first_name} ${appointmentData?.data?.user?.last_name}`}</p>
                                <p>Age : {appointmentData?.data?.user?.familyDetail?.age ?? "N/A"}</p>
                                <p>City : {appointmentData?.data?.user?.detail?.city ?? "N/A"}</p>
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                <p>Address : {appointmentData?.data?.user?.detail?.address ?? "N/A"}</p>
                                <p>Medical Condition : {appointmentData?.data?.user?.familyDetail?.medical_condition ?? 'N/A'}</p>
                                <p>Special Needs : {appointmentData?.data?.user?.familyDetail?.special_needs ?? 'N/A'}</p>
                            </Col>
                        </Row>
                    </Card>
                    <Card
                        title="Appointment Detail"
                        style={{ marginBottom: 24 }}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                <p>Date : {new Date(appointmentData?.data?.date).toLocaleDateString('en-us', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                })}</p>
                                <p>Shift : {appointmentData?.data?.shift ?? 'N/A'}</p>
                                <p>Start Time : {appointmentData?.data?.start_time ?? 'N/A'}</p>
                                <p>End Time : {appointmentData?.data?.end_time ?? 'N/A'}</p>
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                <p>Amount : {appointmentData?.data?.transaction?.amount ?? 'N/A'}</p>
                                <p>Status : {appointmentData?.data?.status ?? 'N/A'}</p>
                                <p>Review : {appointmentData?.data?.review ?? 'N/A'}</p>
                                <p>Rating : {appointmentData?.data?.rating ?? 'N/A'}</p>
                            </Col>
                        </Row>
                    </Card>
                </>
            } />

        </>
    );
}

export default AppointmentDetail;